import { api } from '@marketplace-web/core-api/core-api-client-util'

import { FaqEntryResp } from '../types/faq-entry'
import { GetPluginsByFeatureArgs, PluginsByFeatureResponse } from '../types/get-plugins-by-feature'
import { GetItemsByNameArgs, ItemsByNameResponse } from '../types/items-block'

export const getPluginsByFeature = ({ itemId, feature, params }: GetPluginsByFeatureArgs) =>
  api.get<PluginsByFeatureResponse>(`/items/${itemId}/plugins/${feature}`, { params })

export const getItemsByName = ({ itemId, name }: GetItemsByNameArgs) =>
  api.get<ItemsByNameResponse>(`/items/${itemId}/more`, {
    params: { content_source: name, screen: 'item' },
  })

export const getFaqEntryById = (id: string) => api.get<FaqEntryResp, unknown>(`/faq_entries/${id}`)
